define.alias("shared/components/shared/ui/search-box/results", "calendar/components/shared/ui/search-box/results");